
import { resolve } from "path";
import { post , get, put} from "services/config"


export const _getDomains = async (path = '/api/domains')=>{
    try {   
        const response:any = await get(path);
        return response.data.data.map((el:any)=>({label:el.name, value: el.name,id: el.id, audio:el.audio}));
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}

export const _getCurrencies = async (path='/api/currencies')=>{
    try {
        const res:any = await get(path)

        return res.data.data
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data')
    }
}



export const _getProfileWorker = async (path = '/api/freelance/my-profil')=>{
    try {
        const response:any = await get(path);
        console.log({response})
        return response.data.data
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}

export const _updateProfileWorker = async (payload ={}, config={}, path = '/api/freelance/update-profil',)=>{
    try {
        const response:any = await post(path, payload, {withCredentials: true, ...config});
        console.log({response})
        return response.data
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}




export const _getSkills = async (path = '/api/competences')=>{
    try {
        const response:any = await get(path);
        return response.data.data.map((el:any)=>({label:el.name, value: el.name,id: el.id, domain_id: el.domain_id}));;
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}

export const _getLangs = async (path = '/api/langs')=>{
    try {
        const response:any = await get(path);
        console.log({response})
        return response.data.data.map((el:any)=>({label:el.name, value: el.name, id: el.id}));
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}

export const _getTools = async (path = '/api/tools')=>{
    try {
        const response:any = await get(path);
        console.log({response})
        return response.data.data.map((el:any)=>({label:el.name, value: el.name, id: el.id}));
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}

export const _getFreelanceStatus = async (path='/api/freelance/status')=>{
    try {
        const response:any = await get(path);
        console.log({response})
        return response.data.data.map((el:any)=>({label:el.name, value: el.name, id:el.id}));
    } catch (error:any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}

export const __search = async (query:any, path='/api/search')=>{
    try{
        const response:any = await get(`${path}${query?`?search=${query}`:''}`)
        console.log("test",{response})
        return response.data.data
    }catch(error:any){
        console.log({error})
    }
}

export const _getFreelances = async (queryString:string,path = '/api/freelances')=>{
    try {
        const response:any = await get(path+queryString);
        return {data:response.data.data, average_price_review: response.data.average_price_review ,pagination:{total_pages:response.data.total_pages}}
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}

export const _getFilters = async (path = '/api/filters')=>{
    try {
        const response:any = await get(path);
        return response.data.data
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Failed to get data');
    }
}